<template>
    <form class="searchbar">
      <div class="input-group" :class="{ 'expanded': visible }" >
        <input type="text" v-if="visible" class="form-control" placeholder="Search"
               aria-label="Wpisz frazę i zatwierdź w celu rozpoczęcia wyszukiwania." aria-describedby="button-addon2" ref="searchInput">
        <button class="btn btn-outline-primary"
                :class="{ 'btn-ghost': !visible }"
                type="button"
                @click.prevent="toggle"
                aria-label="Wybierz aby wyświetlić pole formularza"
                id="button-addon2"><i class="bi bi-search"></i></button>
      </div>
    </form>
</template>
<script>
import Vue from 'vue';
export default {
  name: 'search',
  components: {},
  data() {
    return {
      visible: false,
    }
  },
  methods: {
    toggle() {
      if (this.visible === true)
        this.visible = false
      else if (this.visible === false) {
        this.visible = true;
        // this.$refs.searchInput.focus();
        Vue.nextTick(() => {
          this.focusInput();
        });
        // document.getElementById("search-input").focus();
      }
    },
    focusInput() {
      this.$refs.searchInput.focus();
    }
  }
}

</script>